var burger = document.querySelector("#burger");
var header = document.querySelector("#header");
var body = document.querySelector("body");
var btnCart = document.querySelector("#btn-cart");
var btnCloseCart = document.querySelector("#cart .close");
var btnContinueShop = document.querySelector("#cart .close-cart");
var btnSearch = document.querySelector("#btn-search");
var btnCloseSearch = document.querySelector("#search .close");
var closeGlobal = document.querySelectorAll(".close-global");
var closeBandeau = document.querySelector("#close-bandeau");
var bandeauPromo = document.querySelector(".content-bandeau-promo");
//var closeBandeau = document.querySelector("#header .content-bandeau-promo .content-close");
var moduleOpen = false;

const ruptureBurger = 992;

function majStateModuleOpen(){
    if(moduleOpen){
        moduleOpen = false;
    }else{
        moduleOpen = true; 
    }
}

if(bandeauPromo != null){
    bandeauPromo.querySelector(".btn-show").addEventListener("click", function(){
        bandeauPromo.classList.toggle("show");
        header.classList.toggle("bandeau-open");
        body.classList.toggle('freeze-promo');
        document.querySelector("html").classList.toggle('freeze-promo'); 
    }); 
} 

 

btnCloseSearch.addEventListener("click", () => {
    header.classList.toggle('search-open'); 
    body.classList.toggle('freeze');
    document.querySelector("html").classList.toggle('freeze'); 
});

closeGlobal.forEach(c => {
    c.addEventListener("click", () => {
        header.classList.remove('search-open');
        header.classList.remove('cart-open');
        if(header.classList.contains("chat-open")){
            header.classList.remove('chat-open'); 
            if(typeof GorgiasChat != "undefined"){
                GorgiasChat.close();  
            }
        } 
        if(header.classList.contains("menu-open")){
            header.classList.remove('menu-open');  
        } 
        if(burger.classList.contains("active")){
            burger.classList.remove("active")
        };
        if(header.classList.contains("bandeau-open")){
            header.classList.remove('bandeau-open');  
        } 
        if(bandeauPromo != null &&bandeauPromo.classList.contains("show")){
            bandeauPromo.classList.remove("show");
        }
        body.classList.remove('freeze');
        document.querySelector("html").classList.remove('freeze'); 
        body.classList.remove('freeze-promo');
        document.querySelector("html").classList.remove('freeze-promo'); 
    }); 
});  
 
if(closeBandeau != null){
    closeBandeau.addEventListener("click", () => { 
        bandeauPromo.classList.remove("show");
        header.classList.remove("bandeau-open");
        body.classList.remove('freeze-promo');
        document.querySelector("html").classList.remove('freeze-promo'); 
    });  
}

var menuLink0 = document.querySelectorAll(".menu-left .link-level0.plus"); 
menuLink0.forEach(m => {
    m.addEventListener("click", function(e){
        e.preventDefault();
        if(document.querySelector("body").offsetWidth < ruptureBurger){ 
            m.closest(".cat").classList.toggle("open"); 
        }else{
            window.location.href = m.getAttribute("href");
        }
    });
}); 

var menuLink1 = document.querySelectorAll(".menu-left .level1 h3.plus"); 
menuLink1.forEach(m => {
    m.addEventListener("click", function(e){ 
        if(document.querySelector("body").offsetWidth < ruptureBurger){ 
            m.closest(".level1").classList.toggle("open"); 
        } 
    });
});   
 
function cssLoaded(){
    document.dispatchEvent(new Event('cssLoaded')); 
}  

function pushCss(href){
    var link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", href);
    link.setAttribute("onload", "cssLoaded();");
    document.querySelector("head").appendChild(link);
  }


document.addEventListener("cssLoaded", () => {
    document.querySelectorAll(".toload").forEach(l => {
      l.classList.add("loaded");
    });
});

function getParams(parameterName) {
    var result = null,
        tmp = [];
    location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (decodeURIComponent(tmp[0]) === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
}
 
//Check param form news
if(getParams("contact[tags]") != null){
    if(getParams("contact[tags]").indexOf("newsletter") > -1){ 
        let contentNewsFooter = document.querySelector(".footer .content-news");
        contentNewsFooter.querySelector("form").remove();
        contentNewsFooter.querySelector("p").textContent = "Vous êtes déjà abonné à notre newsletter.";
    }
} 

document.querySelectorAll(".link-target").forEach(l => {
    l.addEventListener("click", (e) => {
        e.preventDefault();
        let target = document.querySelector(l.getAttribute("href"));
        let targetPos = target.offsetTop;
        let headerH = document.querySelector("#header").offsetHeight;
        window.scroll(0, targetPos-headerH);
    });
});
   



function closeAllExcept(exception) {
    if (exception !== 'menu' && header.classList.contains('menu-open')) {
        header.classList.remove('menu-open');
        burger.classList.remove('active');
    }
    if (exception !== 'search' && header.classList.contains('search-open')) {
        header.classList.remove('search-open');
    }
    if (exception !== 'cart' && header.classList.contains('cart-open')) {
        if (typeof novCart !== "undefined") {
            novCart.closeCart();
        }
    }
    if (exception !== 'menu' && exception !== 'search' && exception !== 'cart') {
        body.classList.remove('freeze');
        document.querySelector("html").classList.remove('freeze');
    }
}

burger.addEventListener("click", () => {
    const isOpen = header.classList.contains('menu-open');

    if (isOpen) {
        header.classList.remove('menu-open');
        burger.classList.remove('active');
        body.classList.remove('freeze');
        document.querySelector("html").classList.remove('freeze');
    } else {
        closeAllExcept('menu');
        header.classList.add('menu-open');
        burger.classList.add('active');
        body.classList.add('freeze');
        document.querySelector("html").classList.add('freeze');
    }
});

if (btnCart != null) {
    btnCart.addEventListener("click", () => {
        const isOpen = header.classList.contains('cart-open');

        if (isOpen) {
            if (typeof novCart !== "undefined") {
                novCart.closeCart();
            }
            body.classList.remove('freeze');
            document.querySelector("html").classList.remove('freeze');
        } else {
            closeAllExcept('cart');
            if (typeof novCart !== "undefined") {
                novCart.openCart();
            }
            body.classList.add('freeze');
            document.querySelector("html").classList.add('freeze');
        }
    });

    btnCloseCart.addEventListener("click", () => {
        if (typeof novCart !== "undefined") {
            novCart.closeCart();
        }
        body.classList.remove('freeze');
        document.querySelector("html").classList.remove('freeze');
    });

    btnContinueShop.addEventListener("click", () => {
        if (typeof novCart !== "undefined") {
            novCart.closeCart();
        }
        body.classList.remove('freeze');
        document.querySelector("html").classList.remove('freeze');
    });
}

btnSearch.addEventListener("click", () => {
    const isOpen = header.classList.contains('search-open');

    if (isOpen) {
        header.classList.remove('search-open');
        body.classList.remove('freeze');
        document.querySelector("html").classList.remove('freeze');
    } else {
        closeAllExcept('search');
        header.classList.add('search-open');
        body.classList.add('freeze');
        document.querySelector("html").classList.add('freeze');
    }
});

btnCloseSearch.addEventListener("click", () => {
    header.classList.remove('search-open');
    body.classList.remove('freeze');
    document.querySelector("html").classList.remove('freeze');
});
